/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_CompressInputs */



/**
* | output |
* | --- |
* | "Compress" |
*
* @param {Shortcut_Keys_Name_CompressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_compress = /** @type {((inputs?: Shortcut_Keys_Name_CompressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_CompressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Compresser")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kompresse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Comprimere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Компресс")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comprimir")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("压缩")
	if (locale === "ja") return /** @type {LocalizedString} */ ("圧縮")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संकुचित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Compressa")
	return /** @type {LocalizedString} */ ("Compress")
});